<div id="int-settings-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.settings.title' | translate">
    <reactive-button
      actions
      [label]="'general.cancel' | translate"
      [disabled]="isSaving()"
      icon="close"
      variant="outlined"
      severity="secondary"
      (onClick)="revertSettings()"
    ></reactive-button>
    <reactive-button
      actions
      [label]="'general.save' | translate"
      [disabled]="!settingsForm.touched"
      [loading]="isSaving()"
      icon="save"
      variant="outlined"
      (onClick)="saveSettings()"
    ></reactive-button>
  </app-internal-toolbar>

  <div class="h-fit overflow-auto m-4">
    <form
      [formGroup]="settingsForm"
      class="flex flex-col justify-center items-center gap-2 w-2/3 m-auto"
    >
      <p-fieldset [legend]="'internal.settings.categories.music' | translate" class="w-full">
        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.enableSongRequests.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.enableSongRequests.description' | translate"
            ></div>
          </div>
          <p-toggleswitch formControlName="enableSongRequests" />
        </label>

        <p-divider />

        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.songRequestTimeouts.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.songRequestTimeouts.description' | translate"
            ></div>
          </div>
          <p-inputnumber formControlName="songRequestTimeouts" suffix=" s" />
        </label>

        <p-divider />

        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.enableSchulradio.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.enableSchulradio.description' | translate"
            ></div>
          </div>
          <p-toggleswitch formControlName="enableSchulradio" />
        </label>
      </p-fieldset>

      <p-fieldset [legend]="'internal.settings.categories.gallery' | translate" class="w-full">
        <label class="flex flex-mobile items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.defaultGallery.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.defaultGallery.description' | translate"
            ></div>
          </div>
          @if (loadingCategories()) {
            <p-skeleton height="2.625rem" width="14rem" />
          } @else {
            <p-select
              [options]="imageCategories()"
              formControlName="defaultGallery"
              optionLabel="title"
              optionValue="_id"
              class="w-full md:w-56"
            />
          }
        </label>
      </p-fieldset>

      <p-fieldset [legend]="'internal.settings.categories.inventory' | translate" class="w-full">
        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.allowGroupsForBookIn.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.allowGroupsForBookIn.description' | translate"
            ></div>
          </div>
          <p-toggleswitch formControlName="allowGroupsForBookIn" />
        </label>

        <p-divider />

        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.allowReturnItemsNotInTransaction.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.allowReturnItemsNotInTransaction.description' | translate"
            ></div>
          </div>
          <p-toggleswitch formControlName="allowReturnItemsNotInTransaction" />
        </label>

        <p-divider />

        <label class="flex items-center justify-between gap-12 select-none w-full">
          <div class="flex-1">
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.allowItemRebooking.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.allowItemRebooking.description' | translate"
            ></div>
          </div>
          <p-toggleswitch formControlName="allowItemRebooking" />
        </label>

        <p-divider />

        <label class="flex flex-col items-start justify-between gap-6 select-none w-full">
          <div>
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.labelTemplate.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.labelTemplate.description' | translate"
            ></div>
          </div>
          <textarea
            pTextarea
            formControlName="labelTemplate"
            rows="10"
            cols="30"
            class="w-full"
          ></textarea>
        </label>

        <p-divider />

        <label class="flex flex-col items-start justify-between gap-6 select-none w-full">
          <div>
            <div
              class="text-color font-bold"
              [innerHTML]="'internal.settings.groupLabelTemplate.title' | translate"
            ></div>
            <div
              class="text-muted-color"
              [innerHTML]="'internal.settings.groupLabelTemplate.description' | translate"
            ></div>
          </div>
          <textarea
            pTextarea
            formControlName="groupLabelTemplate"
            rows="10"
            cols="30"
            class="w-full"
          ></textarea>
        </label>
      </p-fieldset>
    </form>
  </div>
</div>
